import React from 'react';
import i18n from '../i18n';

class ErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('Unhandled render error:', error, info);
  }

  componentDidUpdate(prevProps) {
    if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false });
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          role="alert"
          style={{
            display: 'flex', flexDirection: 'column', alignItems: 'center',
            justifyContent: 'center', gap: 12, padding: '48px 24px',
            textAlign: 'center', minHeight: '50vh',
          }}
        >
          <div style={{ fontSize: 32 }}>⚠️</div>
          <h2 style={{ margin: 0, fontSize: 18, fontWeight: 700, color: '#1E293B' }}>
            {i18n.t('errorBoundary.title')}
          </h2>
          <p style={{ margin: 0, color: '#64748B', fontSize: 14, maxWidth: 360 }}>
            {i18n.t('errorBoundary.description')}
          </p>
          <button
            onClick={() => window.location.assign('/')}
            style={{
              marginTop: 8, padding: '10px 20px', borderRadius: 8, border: 'none',
              background: '#4F46E5', color: '#fff', fontWeight: 600, fontSize: 14,
              cursor: 'pointer',
            }}
          >
            {i18n.t('errorBoundary.backToHome')}
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
